/*eslint-disable*/
const LangTransferBalance = {
	"transferBalance.validate._noStoreValue": [
		"This card has no store value balance.",
		"កាត​នេះ​ ពុំ​មានទឹក​ប្រាក់​​​",
	],
	"transferBalance.header._transferFrom": ["TRANSFER FROM", "ផ្ទេរ​ទឹក​ប្រាក់​មក​ពី"],
	"transferBalance.header._transferTo": ["TRANSFER TO", "ផ្ទេរ​ទឹក​ប្រាក់​​ទៅ​កាន់"],
	"transferBalance.rules._maxAllow": [
		"A maximum of ${maxAllow} can be stored in one card at any one time",
		"កាត​មួយ អាចមាន​​ទឹក​ប្រាក់​​​អតិបរមា​ចំនួន ${maxAllow}",
	],
}

export default LangTransferBalance



// WEBPACK FOOTER //
// ./src/resources/pages/LangTransferBalance.js